const search = {
  PLAYERS: '/search/players',
  TRANSACTIONS: '/search/transactions',
  PAYCARDS: '/search/paycards',
}

export default search
